"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _NotificationBarWithMessages = _interopRequireDefault(require("./../../components/NotificationBarWithMessages"));

var _actions = require("./../../actions");

var _context = require("./../../context");

var mapStateToProps = function mapStateToProps(state, props) {
  // only return the message if this is the one thats actually in the viewport
  var activePlaceholder = 'activePlaceHolderFullScreen';
  var messagesKey = 'fullScreenMessages';

  if (props.targetKey === 'wizard') {
    activePlaceholder = 'activePlaceHolderWizard';
    messagesKey = 'wizardMessages';
  }

  if (props.targetKey === 'page') {
    activePlaceholder = 'activePlaceHolderPage';
    messagesKey = 'pageMessages';
  }

  if ((0, _get["default"])(state, "".concat(activePlaceholder, ".id")) === props.id) {
    return {
      messages: (0, _get["default"])(state, "".concat(messagesKey))
    };
  }

  return {};
};

var connect = function connect(mapState) {
  return function (WrappedComponent) {
    return function (props) {
      var _useContext = (0, _react.useContext)(_context.NotificationBarContext),
          state = _useContext.state,
          dispatch = _useContext.dispatch;

      return _react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, mapState(state, props), {
        dispatch: dispatch,
        hideBar: _actions.hideBar
      }));
    };
  };
};

var _default = connect(mapStateToProps)(_NotificationBarWithMessages["default"]);

exports["default"] = _default;